import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'
import { v4 } from 'uuid'

export const historySlice = createSlice({
    name: 'history',
    initialState: {
        historydetail:{},
        historysuccess:0,
        triggerExcel: '',
        historyfail:'',
        historyFailData:[],
        historyDefault: [],
        memberOneFail: [],
        memberSuccess: [],
        member_fail: []

    },
    reducers: {
        setMemberOneFailRedux: (state, action) => {
            state.memberOneFail = action.payload.memberOneFail
        },
        setMemberSuccessRedux: (state, action) => {
            state.memberSuccess = action.payload.memberSuccess
        },
        setMemberFailRedux: (state, action) => {
            state.member_fail = action.payload.member_fail
        },
        setHistoryDetail: (state, action) => {
            state.historydetail = action.payload.historydetail
        },
        setHistorySuccess: (state, action) => {
        state.historysuccess = action.payload.historysuccess
        },
        setHistorySuccessIncrease: (state, action) => {
            state.historysuccess =  state.historysuccess + 1
            state.historyfail =  state.historyfail - 1
        },
        setHistoryFail: (state, action) => {
            state.historyfail = action.payload.historyfail
        },
        setHistoryFailDataRedux: (state, action) => {
            state.historyFailData = action.payload.historyFailData
        },
        setHistoryFailDataWithIndexRedux: (state, action) => {
            state.historyFailData[action.payload.index] = action.payload.data
        },
        setHistoryFailDataLoadingWithIndexRedux: (state, action) => {
            state.historyFailData[action.payload.index].loading = action.payload.loading
        },
        setHistoryFailDataTitleTHWithIndexRedux: (state, action) => {
            state.historyFailData[action.payload.index].title_th = action.payload.title_th
        },
        setHistoryFailDataTitleENWithIndexRedux: (state, action) => {
            state.historyFailData[action.payload.index].title_en = action.payload.title_en
        },
        setHistoryFailToSuccess: (state, action) => {
            state.historydetail.importHistories[state.historydetail.importHistories.length - 1].failDetail = state.historydetail.importHistories[state.historydetail.importHistories.length - 1].failDetail.filter((member,index)=>{
                if(member.request.index != action.payload.index){
                return true
                }
            })
            state.historydetail.importHistories[state.historydetail.importHistories.length - 1].successDetail.push(action.payload.detail)
        },
        setHistoryDefault: (state, action) => {
            const { historyDefault } = action.payload
            state.historyDefault = historyDefault
        },
        setTrickerExcel: (state, action) => {
            state.trickerExcel = v4()
        },
    },
  })
  
  export default historySlice.reducer;
  
  export const {
    setHistoryFailDataRedux,
    setHistoryFailDataWithIndexRedux,
    setHistoryFailDataLoadingWithIndexRedux,
    setHistoryFailDataTitleTHWithIndexRedux,
    setHistoryFailDataTitleENWithIndexRedux,
    setMemberOneFailRedux,
    setMemberSuccessRedux,
    setMemberFailRedux,
    setHistoryDetail,
    setHistorySuccess,
    setHistorySuccessIncrease,
    setHistoryFail,
    setHistoryFailToSuccess,
    setHistoryDefault,
    setTrickerExcel
  } = historySlice.actions
  
export const getHistoryDetail = (state) => state.history.historydetail
export const getHistorySuccess = (state) => state.history.historysuccess
export const getHistoryFail = (state) => state.history.historyfail
export const getHistoryDefault = (state) => state.history.historyDefault
export const getMemberOneFailRedux = (state) => state.history.memberOneFail
export const getMemberSuccessRedux = (state) => state.history.memberSuccess
export const getMemberFailRedux = (state) => state.history.member_fail
export const getHistoryFailDataRedux = (state) => state.history.historyFailData
export const getTrickerExcel = (state) => state.history.triggerExcel
